module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_vm._v("HOPE FLOATS")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Hope "), _c('i', [_vm._v("floats")]), _vm._v(", as a fated ship is dragged to its demise on the seabed. Hope "), _c('i', [_vm._v("rises")]), _vm._v(" when everything else is sinking. Hope "), _c('i', [_vm._v("flies")]), _vm._v(" when there are no wings and hope "), _c('i', [_vm._v("drives")]), _vm._v(", without an engine. Hope does not need light or oxygen to survive. It grows best in the dark, truth be told. Hope is the 1 per cent that rallies against statistics. The one they cannot "), _c('i', [_vm._v("explain")]), _vm._v(". Hope is against the odds, in spite of fact and solely made of "), _c('i', [_vm._v("will")]), _vm._v(". Hope is the space between faith and spirit. Hope is the belief that things can get better, that the sun will warm again, that the end need not be that. Hope lives in the mud, in the mire, in the barren wasteland of emptiness. It is like "), _c('i', [_vm._v("magic")]), _vm._v(", this hope. And the best thing of all? It’s free; you just have to call it near. Hope floats, my friends, cling on to it when you are just too tired to swim.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec1"
    }
  }, [_vm._v("AND ON WE GO")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is much power")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the phrase")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("and on we go")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("we break and rebuild")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("knowing we will break again")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("we lose but still love though")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("we know the pain won’t end")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("we struggle along alone")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("yet we stop along the way")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("to help another stand")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("to see a brighter day")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("no matter what we have faced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("how hard we have smashed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("against the rocks of life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we wash up")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we shed tears")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we wail to the skies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we let go")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we rest")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we brush down")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("we shake off")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("and on we go …")])]), _vm._v(" "), _c('p', {
    staticClass: "image",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec2"
    }
  }, [_vm._v("DON’T LOSE HOPE")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Put hope in a safe place. Not a "), _c('i', [_vm._v("super-safe")]), _vm._v(" place; the place we cleverly stash things in, never to be seen again. Just a safe, everyday place. Like beside your car keys. Put hope beside your car keys, and each time you leave the house, you’ll see hope glistening there and you won’t forget to take it with you. And if you’re careful with hope, you’ll never lose it again. You’ll never experience that numb, hapless cloud that descends upon your life with its soul-sucking, vacuous apathy. Without your car keys, you’re going nowhere. It’s the same with hope. Hope is the engine, the steering wheel, the power in your life. Keep it safe. Don’t lose hope. Keep it with your keys. You need it more than you may know.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec3"
    }
  }, [_vm._v("SHADOWS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We have all awoken")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("sharply startled in the night")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("suddenly fearful")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of the brooding shadow")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("in the corner of our room")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("hearts beating in our ears")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we scramble for the light")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("only to be greeted")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("by a pile of clothes on a chair")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("life is like that")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("shine light into the dark corners")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("of your mind")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("take a good look")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("at the scary parts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you are afraid to enter into")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("they are quite different")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("once that light is on them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("they cannot hold any power over you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("in the burning glare of your shine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("light them up my friends")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("light up the shadows")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and scare them away")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("for good.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec4"
    }
  }, [_vm._v("JOY CHOSE YOU")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joy does not arrive with a fanfare")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("on a red carpet strewn")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("with the flowers of a perfect life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("joy sneaks in")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as you pour a cup of coffee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("watching the sun")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("hit your favourite tree")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("just right")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and you usher joy away")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("because you are not ready for her")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("your house is not as it should be")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("for such a distinguished guest")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but joy, you see")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cares nothing for your messy home")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("or your bank balance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("or your waistline")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("joy is "), _c('i', [_vm._v("supposed")]), _vm._v(" to slither through")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the cracks of your imperfect life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("that’s how joy "), _c('i', [_vm._v("works")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you cannot truly invite her")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you can only be ready")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when she appears")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and hug her with meaning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("because in this very moment")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("joy chose you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec5"
    }
  }, [_vm._v("RISK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Believing tomorrow")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to be a guarantee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("is the biggest mistake we make")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("not seizing every day")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("like the gift that it is")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("is the biggest risk we take")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("do what makes you happy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("love your loved ones "), _c('i', [_vm._v("fiercely")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("speak up")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("say the words")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("do the "), _c('i', [_vm._v("stuff")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ride the waves")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("head down through the storms")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("accept the dark")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("the light will follow")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("it’s all part of it")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("it’s life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("it’s meant to feel good")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("it’s meant to feel hard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("just feel it "), _c('i', [_vm._v("all")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("believing tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("to be a guarantee")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("is the biggest mistake we make")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("not seizing every day")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("like the gift that it is")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("is the biggest risk we take.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec6"
    }
  }, [_vm._v("TOO MANY SUNDAYS")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Too many Sundays have been darkened by the dreaded presence of Monday, looming in like a storm cloud of fear, anxiety and gut-wrenching stress. Sunday is your gift, your day to recharge, your freedom. Be protective of that time. Monday has its space enough; do not let it overstep its mark. Make your plans, prepare, then push Monday back into its box and let Sunday shine forth like the jewel it is. You deserve this day of soul rest. Life is not a chore to be dealt with; it’s to be lived, my friend. You’re here to "), _c('i', [_vm._v("live")]), _vm._v(". And Sunday is a day, gifted to us, for doing whatever your little heart desires.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec7"
    }
  }, [_vm._v("REASON SEASON")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where are the books")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("on friendship break-ups?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("pray, where are the self-help manuals")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to pull you through that confusion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("that "), _c('i', [_vm._v("heartache")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where are the songs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the poems")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("the words to help heal?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("because if you have ever been there")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you know")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("the pain of a lost connection")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the torture of not knowing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where it went awry")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the frustration of not being able")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("to fight for the love lost")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where are the books")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("on friendship break-ups?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("reason, season, lifetime")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("they say")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but sometimes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the "), _c('i', [_vm._v("reason")]), _vm._v(" may not become known")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and the "), _c('i', [_vm._v("season")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("is forever committed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to fond remembrance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("for a "), _c('b', [_c('i', [_vm._v("lifetime")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec8"
    }
  }, [_vm._v("UNLEASH")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Don’t be afraid to be alone until you find those people who can handle the whole of you – not just handle (you are not a trophy), but "), _c('i', [_vm._v("relish")]), _vm._v(". Life is too precious to waste it being a slither, a slip, a 2D version of yourself. Make some time to accept all that you are – the messy, the raw, the loud and the joyous – and then go out there and take up some space without apologising for the realness you leave in your wake. Unleash, my friend, "), _c('i', [_vm._v("unleash")]), _vm._v(". Life is only half-lived until you show up proud and true. Just you, being "), _c('i', [_vm._v("you")]), _vm._v(", as only "), _c('i', [_vm._v("you")]), _vm._v(" can do.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec9"
    }
  }, [_vm._v("LISTEN FOR ME")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Listen for me in the music")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the songs we held so dear")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ll find a way to play them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("so you will feel me near")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("each verse will lift your spirits")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("embrace your weary soul")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("each word my soul is sending")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("to help you feel more whole")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("listen for me in the music")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and nature’s music too")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the birds will sing my message")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("they’ll chorus my love for you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the wind will play the trees")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as you are walking by")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("if you listen very closely")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("my heart’s in every sigh")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("listen for me my love")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ll find a million ways")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to whisper in your ear")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("that I’m not so far away.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec10"
    }
  }, [_vm._v("A HANDFUL OF YEARS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There will come a day")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when you will glance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("at your child")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("and be met by an adult")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and it will wipe the very floor")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("from under your feet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when you realise")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in that moment")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("that you were only ever minding them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("until they fly away")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("because back then")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when you were so consumed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("with the daily grind of parenting")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("you felt like this was "), _c('i', [_vm._v("forever")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("yet we know")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("nothing truly is "), _c('i', [_vm._v("forever")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("just a handful of years")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you will know them as a child")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and if you are blessed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("many more")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("you will know them as an adult")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("drink them in")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("if you can")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("drink")]), _vm._v(" "), _c('i', [_vm._v("them")]), _vm._v(" "), _c('i', [_vm._v("in")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec11"
    }
  }, [_vm._v("SURROUNDED BY TREASURE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Beautiful people are not always loved")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("rich folks get sad")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("for no reason")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("everyone goes through their share of the joys")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and the pain")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("we all see every season")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("fabulous houses still let the rain in")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("designer bags")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("don’t weather better")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("shiny new cars get to B just the same")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you’ll be warm")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("in an old or new sweater")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("bodies with six-packs ache and fall sick")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("gold watches")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("won’t turn the time back")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a house is a house till it’s filled up with love")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("then a home")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("is what comes out of that")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("love what you have and you’ll have what you love")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("it’s the way to a life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("full of pleasure")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("be kind to your life and your life will be kind")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("look around")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("you’re surrounded by treasure.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/left.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Your battle to fit in was brave, but I hope you see that accepting you were never supposed to is much braver.")]), _vm._v(" "), _c('p', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/right.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec12"
    }
  }, [_vm._v("HELP SOMEONE ELSE")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("On those days when you are "), _c('i', [_vm._v("stuck")]), _vm._v(", when you cannot see yourself for who you are, and you’ve no motivation to move, help someone else. Seek out someone to assist, with anything, as basic or as bold as you like. And as you are doing this "), _c('i', [_vm._v("helping")]), _vm._v(", something wonderful occurs: your brain shifts from inward to "), _c('i', [_vm._v("outward")]), _vm._v(", your heart shifts from apathy to "), _c('i', [_vm._v("empathy")]), _vm._v(", your soul shifts from stuck to "), _c('i', [_vm._v("doing something worthy.")]), _vm._v(" Before you know it, you are so busy absorbing yourself in someone else’s problem, being "), _c('i', [_vm._v("useful")]), _vm._v(", that you may find your monkey brain has been silenced and your true brain, your "), _c('i', [_vm._v("real")]), _vm._v(" mind, has started to move forward again, all of its own accord. On the days when you can’t help yourself, help someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec13"
    }
  }, [_vm._v("FORGOTTEN GRAVY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I love imperfectly mismatched rooms")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("homemade decorations")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and trinkets")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("that tell stories of the past")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I treasure impromptu gatherings")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("with food rustled up from nowhere")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("it’s always just "), _c('i', [_vm._v("enough")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I see the beauty in gifts handed over")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("with words of "), _c('i', [_vm._v("oh it’s nothin")]), _vm._v("g")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("for that simply means the giver")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cannot begin to convey")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("how they really feel about you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I value both the quiet moments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when the lights twinkle privately")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and the raucous occasions")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("when laughter fills the room")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and I can’t get enough of burnt carrots")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("forgotten gravy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("and failed attempts at dessert")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("because that’s where the love lives")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the imperfect")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the messy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("in the real")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("love lives in the forgotten gravy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_c('b', [_vm._v("look for it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec14"
    }
  }, [_vm._v("NOW YOU DO")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t have to defend the old you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you didn’t know then")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("now you "), _c('i', [_vm._v("do")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you did what you could")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("with what you had")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("at the time")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and as with all things in life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you evolved")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("you’ve grown")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("if you find yourself")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("trying in vain")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to defend the "), _c('i', [_vm._v("old")]), _vm._v(" you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to argue on her behalf")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("please stop")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("you don’t have to do that")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("she was someone")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you parted ways with")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("gracefully")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("but after much suffering")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("if anyone in your life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cannot do the same")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("that’s their issue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("it’s their job to catch up")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("not your job to go back")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you don’t have to defend the old you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you didn’t know then")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("now you do.")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/left.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I hope you know that this beautifully messy life you are living will continue to create great love, even after you leave.")]), _vm._v(" "), _c('p', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/right.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec15"
    }
  }, [_vm._v("JUST A DAY")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("No, today probably won’t be a great day, but it absolutely won’t be a bad day either. Today will simply be a day. Twenty-four hours of a little bit of everything. Some moments will be hard, some will be joyous, some will be peaceful and some will be draining. And you, you will handle it all, because that’s what you "), _c('i', [_vm._v("do")]), _vm._v(". Don’t put pressure on yourself to have any kind of a day, my friend. Life throws enough at you. Instead, just remind yourself that whatever happens, you are ready. And most importantly, you have your own back. It’s just a day. Another day of life in all its messy everything-ness. "), _c('b', [_vm._v("Lucky us")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec16"
    }
  }, [_vm._v("THE MOON AND I")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have always loved the moon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but now")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("she and I are locked")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("in an eternal pact of hope")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I ask her how you are")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and she lets me know")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you’re peaceful")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("blissful")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("reminding me")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you still exist within my own bones")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and that she’s simply reflecting that back")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("so I can see it more clearly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I ask her not to stop")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("never to stop")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have always loved the moon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but now she holds me in the night")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when I need to see your face")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I look at hers instead")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and she shows me "), _c('i', [_vm._v("you")]), _vm._v(", my love")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("she reflects you right back")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and I ask her not to stop")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("never to stop")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I always loved the moon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but now")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("she and I are locked")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in an eternal pact of hope")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("an eternal "), _c('i', [_vm._v("remembering")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("of you.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec17"
    }
  }, [_vm._v("IN THE PHOTO")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("It’s easy to shy away from photographs because you’re so busy, so exhausted, not feeling your best. It’s easy to be the "), _c('i', [_vm._v("taker")]), _vm._v(" and never let yourself be in, when holidays make you feel exposed or "), _c('i', [_vm._v("less than")]), _vm._v(". But one day, your loved ones will search for those memories to bolster their own. Those pictures, no matter how you look, are set to become absolutely "), _c('b', [_vm._v("precious")]), _vm._v(". And no one, not one of them, will care how "), _c('i', [_vm._v("together")]), _vm._v(" you appear. They will care, very much, that it is "), _c('i', [_vm._v("you")]), _vm._v(". And all of your "), _c('i', [_vm._v("you-ness")]), _vm._v(" will be the exact gift they very much need in that moment. Be in the photo, my friends. "), _c('i', [_vm._v("They are not for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec18"
    }
  }, [_vm._v("YOU DON’T MEET ANYONE BY ACCIDENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t meet anyone in this life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("by accident")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("some are sent to teach you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("what love "), _c('i', [_vm._v("is")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("some are sent to teach you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("what love most certainly "), _c('i', [_vm._v("isn’t")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("some are sent to support you")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("without falter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and those you must hold")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("very dear indeed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("others are sent to challenge")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("your self-worth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("never let them win")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("some people are taken")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("far too soon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and the lesson there")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("is to live life fully")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("here and now")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and love deeply")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("with every moment you have")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you don’t meet anyone in this life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("by accident")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("each person brings with them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a "), _c('i', [_vm._v("joy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a "), _c('i', [_vm._v("love")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("or a "), _c('i', [_vm._v("lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("pay attention.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec19"
    }
  }, [_vm._v("WITHOUT YOU")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How do I live without you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("oh, my love, I do not")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you are with me from the moment")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I open my eyes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("until they close")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and even after that")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("on the plane of dreams")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("where souls and mortals meet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("you are with me still")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("I’ve not begun to live without you")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("perhaps I never will")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("the truth of the matter is")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("you are always with me still")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("you walked such a blazing pathway")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("when your feet were on this earth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("that your imprint lingers on")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and I place my own feet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in your steps")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("one by one")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("how do I live without you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s really very simple")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I do not")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("I have yet to live without you")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("perhaps I never will")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("perhaps the key to grief is")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("you are always with me still.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec20"
    }
  }, [_vm._v("THE AFTER-PARTY PEOPLE")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Anyone can fill a room full of glittering people. Announce a party, send out invitations, bring food, wine, music and the promise of fun, they will come. But it is the after-party people you must treasure in this life. The ones who stay to help clear away. The ones who see you are exhausted from the organising, and know you will need them then. The ones who call the day before and say, "), _c('i', [_vm._v("What can I help you with?")]), _vm._v(", despite being already overwhelmed in their own lives. The people who will show up for your house move, for your worst days, for your "), _c('i', [_vm._v("broken")]), _vm._v(". The people who stay when the show is over, the curtain has fallen heavily to the stage floor and the make-up is off. It is wonderful to be surrounded by fun-filled faces sometimes, but you only need one face, one little loving face, full of care and friendship, to thrive.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec21"
    }
  }, [_vm._v("WHEN MY TIME COMES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I pray that when my time comes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("no one waxes lyrical")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("about the quality of my skin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("for my age")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I pray that no one")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("compliments my corpse")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("on its great condition")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I want everyone")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to remember")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("me")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the way I showed my face")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to the sun")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("without care for lines")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and how I wore my body out")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("every minute")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of every day")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in the most beautiful")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("and love-filled ways")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was not here to preserve")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I came to "), _c('i', [_vm._v("live")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and my body")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("will tell that story")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("the story of my soul "), _c('i', [_vm._v("well")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("when my time comes.")])]), _vm._v(" "), _c('p', {
    staticClass: "image",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg48_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chap-title",
    attrs: {
      "id": "sec22"
    }
  }, [_vm._v("YOU")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If every single person who has liked you in your lifetime were to light up on a map, it would create the most glitteringly beautiful network you could imagine. Throw in the strangers you’ve been kind to, the people you’ve made laugh, or inspired along the way, and that star-bright web of you would be an impressive sight to behold. You’re so much more than you think you are. You have done so much more than you realise. You’re trailing a bright pathway that you don’t even know about. What a thing. "), _c('i', [_vm._v("What a thing indeed.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b87e6e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 84
// module chunks = 0